<template>
    <div class="dates">
        <label> Latest update: {{ props.sourceDateList.latestSource }} </label>
        <label> Entry Created: {{ props.sourceDateList.creationDate }} </label>
        <br>
        <label>Attribute Updates:</label>
        <div class="attributes-scroll">
            <div v-for="(source, index) in props.sourceDateList.allSources" :key="index">
                <label class="update-dates"> {{ source.dateAdded }}</label>
                <div v-for="(attributeValuePair, index) in source.attributes" :key="index">
                    <p v-if="(attributeValuePair.attribute === 'Status')"><span style=" font-weight: bold"> {{ attributeValuePair.attributeValue }} </span> date added</p>
                    <p v-else><span style="font-weight: bold"> {{ attributeValuePair.attribute }} </span> set to <span style="font-style: italic"> {{ attributeValuePair.attributeValue }} </span></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ISourceDates } from '@/interfaces/storageTracking/ISourceDates.ts';

const props = defineProps<{sourceDateList: ISourceDates}>();

</script>
<style lang="scss" scoped>

.dates {
    padding: var(--defaultSpacing) 0 0 var(--defaultSpacing);
    label {
        font-weight: bold;
        margin-bottom: 0.80px;
        display: block;
        text-emphasis-style: underline;
    }
    .attributes-scroll {
        max-height: 40vh;
        max-width: 40vw;
        overflow-y: auto;
        padding-right: var(--defaultSpacing);
        .update-dates {
            text-align: right;
            color: var(--lcpGrapefruit);
            border-bottom:  1px solid var(--lcpGrapefruit);
        }
    }
    p {
        line-height: 1.5;
    }
}
</style>
